import { Navigate, NavLink, Outlet, useNavigate } from "react-router-dom";
import { ExternalLink, FolderKanban, Handshake, LayoutDashboard, LogOut, Network, Trophy, UserCheck } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { ADMIN_PATH } from "../../lib/api";

const links = [
  { to: `${ADMIN_PATH}/panel`, label: "نظرة عامة", icon: LayoutDashboard, end: true },
  { to: `${ADMIN_PATH}/panel/opportunities`, label: "الفرص البحثية", icon: FolderKanban },
  { to: `${ADMIN_PATH}/panel/registrations`, label: "التسجيلات", icon: UserCheck },
  { to: `${ADMIN_PATH}/panel/coordinators`, label: "المنسّقون", icon: Handshake },
  { to: `${ADMIN_PATH}/panel/achievements`, label: "الإنجازات", icon: Trophy },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  if (user === null) return <main className="page-loader" style={{ minHeight: "100vh" }}><span className="loader" /></main>;
  if (!user) return <Navigate to={ADMIN_PATH} replace />;

  return (
    <div className="admin-shell" dir="rtl" data-testid="admin-panel">
      <aside className="admin-side">
        <div className="brand"><span className="brand-mark"><Network size={22} /></span><span className="brand-text"><b>RESEARCH</b><em>NETWORK</em><span className="brand-sub">لوحة الإدارة</span></span></div>
        {links.map((l) => <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => `admin-link ${isActive ? "active" : ""}`} data-testid={`admin-nav-${l.label}`}><l.icon size={18} />{l.label}</NavLink>)}
        <span className="spacer" />
        <a className="admin-link" href="/" target="_blank" rel="noreferrer" data-testid="admin-view-site"><ExternalLink size={18} />عرض الموقع</a>
        <button className="admin-link" onClick={async () => { await logout(); navigate(ADMIN_PATH); }} data-testid="admin-logout"><LogOut size={18} />تسجيل الخروج</button>
      </aside>
      <main className="admin-main"><Outlet /></main>
    </div>
  );
}
